/** admin/users — API. */
import { http } from '../../_shared/http';
import type { UserListItem, UsersListResponse, CreateUserPayload, UpdateUserPayload } from './types';

export const usersApi = {
  list: (page = 1, limit = 20, userType?: string) => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (userType) params.set('userType', userType);
    return http.get<UsersListResponse>(`/users/list-all?${params.toString()}`);
  },

  create: (payload: CreateUserPayload) => http.post<UserListItem>('/users/create-account', payload),

  update: (id: string, payload: UpdateUserPayload) =>
    http.patch<UserListItem>(`/users/update-account/${id}`, payload),

  updatePassword: (id: string, newPassword: string) =>
    http.patch<void>(`/users/update-password/${id}`, { newPassword }),

  remove: (id: string) => http.del<void>(`/users/delete-account/${id}`),

  /** Upload (or replace) a user's profile photo. `blob` is the cropped square. */
  uploadPhoto: (id: string, blob: Blob) => {
    const formData = new FormData();
    formData.append('file', blob, 'profile.png');
    return http.post<UserListItem>(`/users/${id}/profile-photo`, formData);
  },

  removePhoto: (id: string) => http.del<UserListItem>(`/users/${id}/profile-photo`),
};
